module.exports = __webpack_public_path__ + "5d9b1da4d7df88ce9540c4910c13fada.svg";